import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CaseService } from '../../services/case.service';
import { SharedHttpService } from '../../services/shared-http.service';
import { LookupService } from '../../services/lookup.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-case-companies',
  templateUrl: './case-companies.component.html',
  styleUrls: ['./case-companies.component.scss']
})
export class CaseCompaniesComponent {
  ecaseId: any;
  @Input() loadDataFP: Observable<any>;

  memberTypesArr: any;
  isCompanySearchAndFound: boolean = false;
  caseDetails: any;
  memberTypeId: any;
  caseCompaniesList: any;
  caseCompanyId: any;
  editedObj: any;
  memberTypesArrEdit: any[];
  memberTypeIdEdit: any;
  objInsert: any;
  objEdit: any;
  prosecutionId: any;
  prosecutionArr: any;
  facilityEdit: any;
  cities: any;
  constructor(private lookupService: LookupService, public toastr: ToastrService, public caseService: CaseService, private route: ActivatedRoute, public sharedService: SharedHttpService, public router: Router, private modalService: NgbModal) { }
  facility: any;
  cityId: any;
  commercialRegistrationNo: any;
  ngOnInit(): void {
    this.caseDetails = this.caseService.case;
    let membertype = this.lookupService.getLockup('membertype');
    let datawithoutElryad = [];
    let ryadData = [];
    membertype.map((el: any) => {
      el.id == 5 || el.id == 2 ? ryadData.push(el) : datawithoutElryad.push(el);
    });

    this.memberTypesArr = ryadData;

    this.prosecutionArr = this.lookupService.getLockup('prosecution');
    this.cities = this.lookupService.getLockup('cities');
    this.loadDataFP.subscribe((data) => {
      this.ecaseId = data.eCaseId;
      setTimeout(() => {
        this.loadData();
      }, 100);

    });

  }
  loadData() {
    this.sharedService.get(`api/CaseCompany/GetCaseCompanies?ecaseId=${this.ecaseId}`).subscribe(res => {
      this.caseCompaniesList = res;
    });
  }
  openModal(modal) {
    this.resetFacilityDate();
    this.memberTypeId = undefined;
    this.prosecutionId = undefined;
    this.cityId = undefined;
    this.sharedService.openXLarge(modal);

  }

  numberOnly(event) {
    var inp = String.fromCharCode(event.keyCode);
    let pattern = /^\d+$/;
    if (pattern.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }


  VerificationCommercialRegistrationNo() {
    this.isCompanySearchAndFound = false;
    this.facility = undefined;
    this.sharedService.get(`api/Ingeration/GetCompanyByCR?CR=${this.commercialRegistrationNo}`).subscribe(res => {
      if (res && res.crnumber != null) {
        this.isCompanySearchAndFound = true;
        this.facility = res;
      } else {
        this.isCompanySearchAndFound = false;
        this.facility = undefined
        this.sharedService.showErrorKey("من فضلك تأكد من رقم السجل التجاري");
      }
    }, err => {
      this.isCompanySearchAndFound = false;
      this.facility = undefined
      this.sharedService.showErrorKey("من فضلك تأكد من رقم السجل التجاري");
    })

  }

  resetFacilityDate() {
    this.isCompanySearchAndFound = false;
    this.facility = undefined;
    this.commercialRegistrationNo = undefined;
  }

  CreateOffenderCompany(modal) {
    
    this.objInsert = {
      "companyId": this.facility.companyId,
      "crNumber": this.facility.crnumber,
      "caseId": this.caseDetails.caseId,
      "caseNumber": this.caseDetails.caseNumber,
      "memberTypeId": this.memberTypeId
    }
    
    this.sharedService.post('api/CaseCompany/Insert', [this.objInsert]).subscribe(res => {
      modal.dismiss('Cross click');
      this.sharedService.showSuccessKey("InsertoffenderCompanySuccessfully");
      this.loadData();
    })
  }
  editOffenderCompany(member, modal) {
    this.editedObj = {};
    this.editedObj = { ...member };
    this.memberTypesArrEdit = [];
    this.memberTypesArrEdit = [...this.memberTypesArr];
    this.sharedService.get(`api/Ingeration/GetCompanyByCR?CR=${this.editedObj.crNumber}`).subscribe(res => {
        this.facilityEdit = res;
       
    } );
    this.sharedService.openXLarge(modal);
  }
  selectMemberTypeEdit(e) {
    this.memberTypeIdEdit = e.id;
  }
  onEditOffenderCompany(modal) {

    this.objEdit = {
      "caseCompanyId": this.editedObj.caseCompanyId,
      "memberTypeId": this.memberTypeIdEdit
    };
    
    this.sharedService.post(`api/CaseCompany/UpdateCaseCompanies`, [this.objEdit]).subscribe(res => {
      modal.dismiss('Cross click');
      this.sharedService.showSuccessKey("EditoffenderCompanySuccessfully");
      this.loadData();
    })

  }
  previewMember(member, modal) {
    this.editedObj = {};
    this.editedObj = { ...member };
    this.sharedService.get(`api/Ingeration/GetCompanyByCR?CR=${this.editedObj.crNumber}`).subscribe(res => {
      this.facilityEdit = res;
     
  } );
    this.sharedService.openXLarge(modal);
  }

  deleteOffenderCompany(caseCompanyId: any, mymodal) {
    this.sharedService.openSmall(mymodal);
    this.caseCompanyId = caseCompanyId;
  }
  onDeleteOffenderCompany(modal) {
    this.sharedService.get(`api/CaseCompany/DeleteCaseCompany?CaseCompanyId=${this.caseCompanyId}`).subscribe(res => {
      modal.dismiss('Cross click');
      this.sharedService.showSuccessKey("DeletedSuccessfully");
      this.loadData();
    });

  }
}
